import { render, staticRenderFns } from "./DebugProductDescriptionsPage.vue?vue&type=template&id=5b8880d7&scoped=true"
import script from "./DebugProductDescriptionsPage.vue?vue&type=script&lang=js"
export * from "./DebugProductDescriptionsPage.vue?vue&type=script&lang=js"
import style0 from "./DebugProductDescriptionsPage.vue?vue&type=style&index=0&id=5b8880d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8880d7",
  null
  
)

export default component.exports